module.exports = __webpack_public_path__ + "static/media/MentorFiza.e29eb00c.jpeg";